import utils from "../utils";

export default function successHandler(successCode: number) {
  switch (successCode) {
    case 2010:
      return utils.toast({
        type: "SUCCESS",
        text: "درخواست شما با موفقیت ثبت شد",
        id: "2010",
      });
    case 2099:
      return utils.toast({
        type: "SUCCESS",
        text: "درخواست شما با موفقیت ثبت شد",
        id: "2099",
      });
    case 2012:
      return utils.toast({
        type: "SUCCESS",
        text: "بروزرسانی شما با موفقیت ثبت شد",
        id: "2010",
      });

    default:
      console.log({ successCode });
      break;
  }
}
